<template>
    <section class="cabinet__wrap">
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100" v-if="showInstruction">
                <div class="cabinet-instruction">
                    <p class="cabinet-instruction__description">
                        На почту {{email}} выслана инструкция от  ПОДПИШИ.ОНЛАЙН. Следуя инструкциям в письме необходимо подписать документы при помощи ЭЦП.
                    </p>
                </div>
            </div>
        </div>
        <div class="cabinet__row">
            <div class="without-commissions" v-if="showPaymentShedule">
                <div class="without-commissions__title">Погашай с карты БЕЗ КОММИСИЙ</div>
                <div class="without-commissions__cards">
                    <div class="without-commissions__card without-commissions__card--mastercard">
                        <div class="without-commissions__card-image"></div>
                        <div class="without-commissions__card-text">mastercard</div>
                    </div>
                    <div class="without-commissions__card without-commissions__card--visa">
                        <div class="without-commissions__card-image"></div>
                    </div>
                </div>
                <a class="without-commissions__link" v-on:click="pay">Погасить с банковской карты</a>
            </div>
        </div>
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-50" v-if="info.title !== ''">
                <cabinet-status :statusImage="info.image">
                    <template slot="title"><span v-html="info.title"></span></template>
                    <template slot="content">{{info.content}}</template>
                </cabinet-status>
            </div>
            <div class="cabinet__column cabinet__column--width-50">
                <call-center :type="'cabinet'"></call-center>
            </div>
        </div>
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100">
                <div class="methods-repayment">
                    <div class="methods-repayment__title">Способы погашения</div>
                    <div class="methods-repayment__content">
                        <router-link tag="a"
                                     class="methods-repayment__block methods-repayment__block--electronic-wallets"
                                     :to="{name: 'RepayElectronicWallets'}" >
                            <div class="methods-repayment__block-image"></div>
                            <div class="methods-repayment__block-text">Электронные кошельки</div>
                        </router-link>
                        <!-- <router-link tag="a"
                                     class="methods-repayment__block methods-repayment__block--cash-terminal"
                                     :to="{name: 'RepayCashTerminals'}" >
                            <div class="methods-repayment__block-image"></div>
                            <div class="methods-repayment__block-text">Наличными в терминале</div>
                        </router-link> -->
                        <router-link tag="a"
                                     class="methods-repayment__block methods-repayment__block--bank-transaction"
                                     :to="{name: 'RepayBankTransaction'}" >
                            <div class="methods-repayment__block-image"></div>
                            <div class="methods-repayment__block-text">Банковским переводом</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="cabinet__row" v-if="!isDesktop">
            <div class="cabinet__column cabinet__column--width-50">
                <calculator v-bind="product" v-if="showCalculator">
                    <template slot="button">
                        <button class="cabinet-calculator__button button button--yellow" v-on:click="goToCalculator">Оформить микрокредит</button>
                    </template>
                </calculator>

                <payment-shedule v-if="showPaymentShedule"></payment-shedule>
            </div>
        </div>
    </section>
</template>

<script>
import CMenu from "@/views/cabinet/cabinet/menu";
import productAdapter from '@/modules/productAdapter';
import widthMixin from '@/modules/mixins/widthMixin';
import dotObject from 'dot-object';

export default {
    name: "CabinetIndex",
    mixins: [widthMixin],
    metaInfo: {
        title: 'Личный кабинет'
    },
    data(){
        return {
            product: '',

            infoTitle: '',
            infoContent: '',
            infoImage: '',
            email: ''
        }
    },
    components: {
        CMenu,
    },
    methods: {
        pay: function(){
           this.$modal.show('monthlyPayment', {
               amountToPay: this.currentLoan.MonthlyPayment,
               amountOfPayment : this.currentLoan.MonthlyPayment,
               balance: this.currentLoan.balance
           });
        },
        goToCalculator(){
            let _this = this;
            _this.$http.get('/scheduleAndGESV', {params: {
                    term: _this.$store.getters['calculator/getField']('term'),
                    amount: _this.$store.getters['calculator/getField']('amount'),
                    productId: _this.$store.getters['calculator/getField']('productID'),
                    calculationType: _this.$store.getters['calculator/getField']('creditType')
                }
            }).then(
                response => {
                    if(response.data.code === 0){
                        if( !response.data.data.exceeds){
                            _this.$http.get('/json/profile').then(
                                (response) => {
                                    if(response.data.code === 0){
                                        let object = dotObject.dot(response.data.data);
                                        if(object['identityData.expirationDate'] === ''){
                                            _this.$router.push({name: 'PassportData'})
                                        }
                                        else if(object['personalData.stationaryPhone'] === ''){
                                            _this.$router.push({name: 'Address'})
                                        }
                                        else if(object['employment.employmentType'] === ''){
                                            _this.$router.push({name: 'Employment'})
                                        }
                                        else if(object['contacts.1.firstName'] === ''){
                                            _this.$router.push({name: 'RelativeContacts'})
                                        }
                                        else{
                                            _this.$router.push({name: 'Refining'})
                                        }
                                    }
                                },
                                (response) => {

                                }
                            )
                        }else{
                            _this.$modal.show('gesv-error');
                        }
                    }
                },
                response => {}
            );
        },
    },
    computed: {
        currentLoan: function(){
            return this.$store.getters['current/getCurrentLoan'];
        },
        showCalculator: function () {
            return this.creditStatus !== 'ACTIVE' && this.creditStatus !== 'EXPIRED'; /// TODO: Поправить все вот это вот
        },
        showPaymentShedule: function () {
            return this.creditStatus === 'ACTIVE' || this.creditStatus === 'EXPIRED';
        },

        creditStatus: function () {
            return this.$store.getters['credit/getField']('creditStatus');
        },
        showInstruction: function(){
          return  this.creditStatus === 'WAITING_SIGN_AGREEMENTS_BY_DIGITAL_SIGNATURE' ||
              this.creditStatus === 'APPROVED_WAITING_SIGN_CONTRACT_BY_DIGITAL_SIGNATURE';
        },
        info: function () {
            switch(this.creditStatus) {
                // MyKhat+
                case 'APPROVED_WAITING_SIGN_CONTRACT_BY_PHYSICAL_SIGNATURE':{
                    // Ожидает подписи на документе отправленом курьерской службой
                    this.infoTitle = 'Ваша заявка одобрена и ожидает подписи ';
                    this.infoContent = 'Курьер привезет документы на подпись в течении 3 дней';
                    this.infoImage = 'repeat';
                    break;
                }
                case 'APPROVED_SIGNED_CONTRACT_BY_PHYSICAL_SIGNATURE':{
                    // Подписан документ отправленый курьерской службой
                    this.infoTitle = 'Ваша заявка одобрена';
                    this.infoContent = 'Деньги будут зачислены на банковский счёт, указанный в заявке.';
	                this.infoImage = null;
                    break;
                }


                // Podpishi.kz
                case 'WAITING_SIGN_AGREEMENTS_BY_DIGITAL_SIGNATURE': {
                    // Ожидает подписи с ПКБ и ГКБ для скоринга ( Podpishi.kz )
                    this.infoTitle = 'Ожидает подписи соглашений';
                    this.infoContent = 'Ожидает подписи соглашений через ЭЦП на сайте ПодпишиОнлайн';
	                this.infoImage = 'repeat';
                    break;
                }
                case 'APPROVED_WAITING_SIGN_CONTRACT_BY_DIGITAL_SIGNATURE': {
                    // Одобрено ожидает подписи офферты на podpishi.kz
                    // ожидание подписание оферты
                    this.infoTitle = 'Ваша заявка одобрена';
                    this.infoContent = 'Ожидает подписи договора и заявления через ЭЦП на сайте ПодпишиОнлайн';
	                this.infoImage = 'repeat';
                    break;
                }


                case 'MANUAL_VERIFICATION':
                case 'ON_MANUAL_VERIFICATION':
                case 'REVISED_VERIFICATION':
                case 'ON_AUTO_VERIFICATION': {
                    // На верификации
                    // Заявка находится на рассмотрении
                    this.infoTitle = 'Ваша заявка принята. <br> Мы сообщим о решении.';
                    this.infoContent = 'Вам будет отправлено SMS-уведомление о решении по заявке на мобильный номер, указанный при регистрации.';
	                this.infoImage = 'bell';
                    break;
                }

                case 'REMITTANCE_PREPARED':
                case 'REMITTANCE_IN_PROGRESS': {
                    // Все подписано, выплаты готовятся либо в процессе
                    // выпалаты готовятся
                    this.infoTitle = 'Ваша заявка одобрена';
                    this.infoContent = 'Деньги будут зачислены на банковский счёт, указанный в заявке.';
	                this.infoImage = null;
                    break;
                }
                case 'ACTIVE': {
                    // Деньги получены, кредит активен.
                    this.infoTitle = 'Деньги зачислены на ваш счет';
                    this.infoContent = 'Не забывайте вовремя вносить ежемесячные платежи';
	                this.infoImage = 'cache';
                    break;
                }
                case 'CANCELED':
                case 'REJECTED': {
                    // Отказано в кредите
                    this.infoTitle = 'К сожалению, ваша заявка отклонена.';
                    this.infoContent = 'Мы не можем назвать точную причину отказа, так как параметров оценки очень много.';
	                this.infoImage = null;
                    break;
                }
            }
            return {
                title: this.infoTitle,
                content: this.infoContent,
	            image: this.infoImage
            }
        }
    },
    mounted() {
        let _this = this;
        this.$store.dispatch('credit/GET_CREDIT_INFO');
        this.$http.get('/json/product').then(
            response => {
                if (response.data.code === 0) {
                    let product = productAdapter.getActiveProduct(response.data.data.available, "MicroProductEngine");
                    this.$store.commit('calculator/updateField', {path: 'productID', value:product.id});
                    _this.product = productAdapter.transformProduct(product);
                }
            },
            response => {
            }
        );
        if( !this.$store.getters['profile/isInited'] ){
            this.$store.dispatch('profile/INIT');
        }
        this.$http.get('/json/profile').then(
            (response) => {
                if (response.data.code === 0) {
                    _this.email = response.data.data.email;
                }
            },
            (response) => {}
        );

    }
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";

.cabinet {
    $mainname: ".cabinet";
    display: inline-flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;

    width: 100%;
    max-width: 1024px;
    margin-top: 20px;

    &__wrap {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;

        max-width: 700px;
        width: 100%;
    }
    &__row {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        flex: 1;
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        padding: 0 0 10px;
        &:empty{
            display: none;
        }
    }
    &__column {
        flex: 1;
        width: 100%;

        &--width-33 {
            min-width: 33%;
            max-width: 33%;
            &:nth-child(1),
            &:nth-child(2) {
                padding-right: 10px;
            }
        }
        &--width-50 {
            min-width: 50%;
            max-width: 50%;
            &:nth-child(1) {
                padding-right: 10px;
            }
        }
        &--width-100 {
            min-width: 100%;
            max-width: 100%;
        }
    }
    &-instruction{
        width: 100%;
        padding: 20px 35px;
        background: #FFB700;
        &__description{
            text-align: left;
            font-size: 16px;
            font-family: $RobotoMedium;
        }
    }
    .cabinet-calculator {
        width: 320px;
        margin: 0 0;
        border-radius: 12px;

        &__button {
            width: 100%;
            margin: 18px 0 0;
            color: $white;
        }
    }
    .methods-repayment {
        $blockname: ".methods-repayment";
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: space-between;

        width: 100%;

        &__title {
            margin: 0 0 10px 7px;
            color: $gray-dim-dark;
            font-size: 18px;
            font-family: $RobotoBold;
        }
        &__content {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: space-between;

            width: 100%;
        }
        &__block {
            display: inline-flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: space-between;

            width: 33%;
            padding: 15px 5px;
            background: #F7F7F7;
            text-decoration: none;
            &--electronic-wallets {
                #{$blockname}__block-image {
                    background: url("~@/assets/svg/icons/icon_4_mk_y.svg") center / contain no-repeat;
                }
            }
            &--cash-terminal {
                #{$blockname}__block-image {
                    background: url("~@/assets/svg/icons/icon_2_mk_y.svg") center / contain no-repeat;
                }
            }
            &--bank-transaction {
                #{$blockname}__block-image {
                    background: url("~@/assets/svg/icons/icon_3_mk_y.svg") center / contain no-repeat;
                }
            }
        }
        &__block-image {
            display: inline-block;
            width: 45px;
            height: 40px;
            margin-bottom: 10px;
        }
        &__block-text {
            color: $gray-dim-dark;
            font-size: 12px;
            font-family: $RobotoRegular;
        }
    }
    .without-commissions {
        $blockname: ".without-commissions";
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: space-between;

        width: 100%;
        padding: 20px 35px;
        background: $yellow-site;

        &__title {
            text-align: left;
            color: $gray-dim-dark;
            font-size: 24px;
            font-family: $RobotoBold;
        }
        &__cards {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: flex-start;

            width: 100%;
            margin: 20px 0;
        }
        &__card {
            display: inline-flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: flex-start;

            &:nth-child(1) {
                margin-right: 17px;
            }
            &-text {
                margin-left: 8px;
                color: $white;
            }
            &-image {
                display: inline-block;
            }
            &--mastercard {
                #{$blockname}__card-image {
                    width: 35px;
                    height: 22px;
                    background: url("~@/assets/svg/footer-black/mastercard.svg") center / contain no-repeat;
                }
            }
            &--visa {
                #{$blockname}__card-image {
                    width: 54px;
                    height: 18px;
                    background: url("~@/assets/svg/footer-black/visa.svg") center / contain no-repeat;
                }
            }
        }
        &__link {
            text-align: left;
            color: $white;
            font-size: 18px;
            font-family: $RobotoMedium;
            text-decoration: underline;
            cursor: pointer;
        }
    }
    &__column--width-100 {
        .methods-repayment {}
    }
    &__column--width-50 {
        .methods-repayment {
            &__block {
                width: 32%;
            }
        }
    }
    &__column--width-33 {
        .methods-repayment {
            align-items: center;

            &__title {
                margin: 0 0 10px 0;
            }
            &__block {
                flex-flow: row wrap;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                margin: 0 0 5px 0;
                padding: 5px;

                &-image {
                    margin: 0 10px 0 0;
                }
            }
            &__content {
                flex-flow: column wrap;
            }
        }
    }
}
.fade-enter-active {
    transition: opacity .5s;
}
.fade-enter{
    opacity: 0;
}
.fade-leave-active{
    display: none;
}
.fade-leave-to{
    display: none;
}
.layout{
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .content{
        flex: 1;
    }
}
@media screen and (max-width: 1024px) {
    .cabinet {
        padding-top: 0px;

        .cabinet__wrap {
            padding: 5px;
            width: 100%;
            max-width: 100%;
        }
    }

    .layout{

    }
}
@media screen and (max-width: 768px){
    .cabinet {
        $mainname: ".cabinet";

        &__wrap {
            padding: 20px 15px;
        }
        &__column {
            flex: 1;
            width: 100%;

            &--width-33 {
                min-width: 100%;
                max-width: 100%;
                &:nth-child(1),
                &:nth-child(2) {
                    padding-right: 10px;
                }
            }
            &--width-50 {
                min-width: 100%;
                max-width: 100%;
                margin-bottom: 10px;
                &:nth-child(1) {
                    padding-right: 0;
                }
            }
            &--width-100 {
                min-width: 100%;
                max-width: 100%;
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .cabinet {
        &-instruction {
            width: 100%;
            padding: 20px;
        }
        &__without-commissions {
            padding: 19px 18px;

            &__title {
                font-size: 20px;
            }
            &__link {
                font-size: 16px;
            }
        }
    }
}
</style>
